import { render, staticRenderFns } from "./TechWarning.vue?vue&type=template&id=4668f836&scoped=true"
import script from "./TechWarning.vue?vue&type=script&setup=true&lang=ts"
export * from "./TechWarning.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4668f836",
  null
  
)

export default component.exports